import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "relative flex flex-col h-full gap-4 p-4 pt-20 overflow-y-auto xl:pt-8" };
const _hoisted_2 = { class: "text-2xl font-bold text-eblack-900 sm:text-3xl" };
const _hoisted_3 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_4 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 sm:gap-4 mb-2" };
const _hoisted_5 = { class: "flex items-center justify-between" };
const _hoisted_6 = { class: "flex h-10 w-10 items-center justify-center rounded-xl border border-emerald-100 bg-emerald-50 text-emerald-600 shadow-sm transition-transform duration-300 group-hover:scale-105" };
const _hoisted_7 = { class: "inline-flex items-center gap-1.5 rounded-full border border-emerald-200/60 bg-emerald-50 px-2.5 py-0.5 text-[11px] font-semibold text-emerald-700" };
const _hoisted_8 = { class: "mt-4" };
const _hoisted_9 = {
    "data-testid": "overview-realized-income",
    class: "text-3xl font-extrabold tracking-tight text-eblack-900 leading-none"
};
const _hoisted_10 = { class: "mt-1.5 text-[13px] font-medium text-eblack-500" };
const _hoisted_11 = { class: "mt-2 flex items-center gap-1 text-xs font-medium text-emerald-700" };
const _hoisted_12 = { "data-testid": "overview-paid" };
const _hoisted_13 = { class: "flex items-center justify-between" };
const _hoisted_14 = { class: "flex h-10 w-10 items-center justify-center rounded-xl border border-rajah-100 bg-rajah-50 text-rajah-600 shadow-sm transition-transform duration-300 group-hover:scale-105" };
const _hoisted_15 = { class: "inline-flex items-center gap-1.5 rounded-full border border-rajah-200/60 bg-rajah-50 px-2.5 py-0.5 text-[11px] font-semibold text-rajah-700" };
const _hoisted_16 = { class: "mt-4" };
const _hoisted_17 = {
    "data-testid": "overview-receivable-income",
    class: "text-3xl font-extrabold tracking-tight text-eblack-900 leading-none"
};
const _hoisted_18 = { class: "mt-1.5 text-[13px] font-medium text-eblack-500" };
const _hoisted_19 = { class: "mt-2 flex items-center gap-1 text-xs font-medium text-rajah-700" };
const _hoisted_20 = { "data-testid": "overview-approved" };
const _hoisted_21 = { class: "flex items-center justify-between" };
const _hoisted_22 = { class: "flex h-10 w-10 items-center justify-center rounded-xl border border-eblack-100 bg-eblack-50 text-eblack-700 shadow-sm transition-transform duration-300 group-hover:scale-105" };
const _hoisted_23 = { class: "inline-flex items-center rounded-full border border-eblack-100 bg-eblack-50 px-2.5 py-0.5 text-[11px] font-semibold text-eblack-600" };
const _hoisted_24 = { class: "mt-4" };
const _hoisted_25 = {
    "data-testid": "overview-total",
    class: "text-3xl font-extrabold tracking-tight text-eblack-900 leading-none"
};
const _hoisted_26 = { class: "mt-1.5 text-[13px] font-medium text-eblack-500" };
const _hoisted_27 = { class: "mt-2.5" };
const _hoisted_28 = { class: "h-1.5 w-full rounded-full bg-eblack-100 overflow-hidden flex" };
const _hoisted_29 = { class: "mt-1 flex items-center justify-between text-xs font-medium text-eblack-400" };
const _hoisted_30 = { class: "text-emerald-700" };
const _hoisted_31 = { class: "flex items-center justify-between" };
const _hoisted_32 = { class: "flex h-10 w-10 items-center justify-center rounded-xl border border-rajah-100 bg-rajah-50 text-rajah-600 shadow-sm transition-transform duration-300 group-hover:scale-105" };
const _hoisted_33 = { class: "inline-flex items-center gap-1.5 rounded-full border border-rajah-200/60 bg-rajah-50 px-2.5 py-0.5 text-[11px] font-semibold text-rajah-700" };
const _hoisted_34 = { class: "mt-4" };
const _hoisted_35 = { class: "text-3xl font-extrabold tracking-tight text-eblack-900 leading-none" };
const _hoisted_36 = { "data-testid": "overview-pending" };
const _hoisted_37 = { class: "mt-1.5 text-[13px] font-medium text-eblack-500" };
const _hoisted_38 = { class: "mt-2.5 flex items-center gap-1.5 flex-wrap" };
const _hoisted_39 = { "data-testid": "overview-rejected" };
const _hoisted_40 = { "data-testid": "overview-cancelled" };
const _hoisted_41 = { "data-testid": "overview-expired" };
const _hoisted_42 = { class: "flex flex-col gap-3 mb-6 sm:flex-row sm:gap-4" };
const _hoisted_43 = { class: "flex justify-end flex-1" };
const _hoisted_44 = { class: "relative w-full md:w-80" };
const _hoisted_45 = ["placeholder"];
const _hoisted_46 = {
    key: 0,
    class: "grid grid-cols-1 gap-5 sm:gap-6 md:grid-cols-2 lg:grid-cols-3"
};
const _hoisted_47 = {
    key: 1,
    class: "grid grid-cols-1 gap-5 sm:gap-6 md:grid-cols-2 lg:grid-cols-3"
};
const _hoisted_48 = {
    key: 2,
    class: "flex flex-col items-center justify-center py-16 bg-ewhite-100 rounded-xl"
};
const _hoisted_49 = { class: "flex items-center justify-center w-20 h-20 mb-4 rounded-full bg-eblack-100" };
const _hoisted_50 = { class: "text-sm text-muted-foreground" };
import { ref, reactive, computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useOverlay } from "@/services/overlay-service";
import { createSidebarConfig } from "@/utils/overlay-utils";
import itineraryRequest from "@/services/admin/itinerary-service.js";
import ItineraryCard from "./components/ItineraryCard.vue";
import ItineraryCardSkeleton from "./components/ItineraryCardSkeleton.vue";
import ItineraryFormSidebar from "./components/ItineraryFormSidebar.vue";
import ItineraryFilter from "./components/ItineraryFilter.vue";
import CustomerModal from "./components/CustomerModal.vue";
import { useItineraryI18n } from "@/domains/itinerary/composables";
import { IconAlertCircle, IconClockHour4, IconCurrencyDollar, IconFileText, IconSearch, } from "@tabler/icons-vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItineraryIndex',
    setup(__props) {
        const overlayService = useOverlay();
        const route = useRoute();
        const { t } = useItineraryI18n();
        const search = ref("");
        const isInitialLoading = ref(true);
        const activeFilter = ref({});
        const itineraries = ref([]);
        const itineraries_list = ref([]);
        const itinerarySelected = ref(null);
        const showCustomerModal = ref(true);
        const currentOverlayId = ref(null);
        const handledQueryItineraryId = ref(null);
        const newCustomerHandler = ref(null);
        const overview = reactive({
            totalItineraries: 0,
            paidItineraries: 0,
            pendingItineraries: 0,
            approvedItineraries: 0,
            rejectedItineraries: 0,
            cancelledItineraries: 0,
            expiredItineraries: 0,
            realizedIncome: 0,
            receivableIncome: 0,
        });
        const totalIncome = computed(() => {
            return overview.realizedIncome + overview.receivableIncome;
        });
        const realizedPercentage = computed(() => {
            if (!totalIncome.value)
                return 0;
            return Math.round((overview.realizedIncome / totalIncome.value) * 100);
        });
        const receivablePercentage = computed(() => {
            if (!totalIncome.value)
                return 0;
            return Math.round((overview.receivableIncome / totalIncome.value) * 100);
        });
        const completedCount = computed(() => {
            return overview.paidItineraries + overview.approvedItineraries;
        });
        function handleSetNewCustomer(customer) {
            newCustomerHandler.value?.(customer);
        }
        function showModal(data = null) {
            itinerarySelected.value = data;
            currentOverlayId.value = overlayService.open(createSidebarConfig({
                component: ItineraryFormSidebar,
                props: {
                    itinerary: itinerarySelected.value,
                    addItinerary,
                    handleShowCustomerModal,
                    onNewCustomer: (fn) => {
                        newCustomerHandler.value = fn;
                    },
                },
                onClose: () => {
                    itinerarySelected.value = null;
                    currentOverlayId.value = null;
                    newCustomerHandler.value = null;
                },
            }));
        }
        function applySearch() {
            refreshDisplayedItineraries();
        }
        function applyFilter(filter) {
            activeFilter.value = { ...filter };
            refreshDisplayedItineraries();
        }
        function toggleStateFilter(stateKey) {
            if (!stateKey || activeFilter.value.state === stateKey) {
                applyFilter({});
            }
            else {
                applyFilter({ state: stateKey });
            }
        }
        function getPercentage(count) {
            if (!overview.totalItineraries || overview.totalItineraries === 0)
                return 0;
            return Math.round((count / overview.totalItineraries) * 100);
        }
        function refreshDisplayedItineraries() {
            const searchValue = search.value.trim().toLowerCase();
            const state = activeFilter.value.state;
            let nextList = [...itineraries.value];
            if (state) {
                nextList = nextList.filter((itinerary) => itinerary.state === state);
            }
            if (searchValue) {
                nextList = nextList.filter((itinerary) => {
                    const code = String(itinerary.code || "").toLowerCase();
                    const customer = `${itinerary.customer?.name || ""} ${itinerary.customer?.last_name || ""}`.toLowerCase();
                    return code.includes(searchValue) || customer.includes(searchValue);
                });
            }
            itineraries_list.value = nextList;
        }
        function getItineraryData() {
            itineraryRequest
                .getItineraries()
                .then((res) => {
                if (res.status === 200) {
                    const sorted = [...res.data].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                    itineraries.value = sorted;
                    refreshDisplayedItineraries();
                    prepareItineraryOverview();
                    openQueryItineraryIfNeeded();
                }
            })
                .catch(console.error)
                .finally(() => {
                isInitialLoading.value = false;
            });
        }
        function addItinerary(itinerary, isUpdating = false) {
            if (isUpdating) {
                const updateInList = (list) => {
                    const index = list.findIndex((item) => item.id === itinerary.id);
                    if (index !== -1)
                        list.splice(index, 1, itinerary);
                };
                updateInList(itineraries.value);
                updateInList(itineraries_list.value);
            }
            else {
                itineraries.value.unshift(itinerary);
            }
            refreshDisplayedItineraries();
            prepareItineraryOverview();
        }
        function prepareItineraryOverview() {
            overview.totalItineraries = itineraries.value.length;
            overview.paidItineraries = itineraries.value.filter((i) => i.state === "PAID").length;
            overview.pendingItineraries = itineraries.value.filter((i) => i.state === "PENDING").length;
            overview.approvedItineraries = itineraries.value.filter((i) => i.state === "APPROVED").length;
            overview.rejectedItineraries = itineraries.value.filter((i) => i.state === "REJECTED").length;
            overview.cancelledItineraries = itineraries.value.filter((i) => i.state === "CANCELLED").length;
            overview.expiredItineraries = itineraries.value.filter((i) => i.state === "EXPIRED").length;
            overview.realizedIncome = itineraries.value
                .filter((i) => i.state === "PAID")
                .reduce((total, i) => total + Number(i.total ?? 0), 0);
            overview.receivableIncome = itineraries.value
                .filter((i) => i.state === "APPROVED")
                .reduce((total, i) => total + Number(i.total ?? 0), 0);
        }
        function onStatusUpdated(updateData) {
            const updateInList = (list) => {
                const index = list.findIndex((item) => item.id === updateData.id);
                if (index !== -1) {
                    list[index] = updateData.itinerary
                        ? { ...list[index], ...updateData.itinerary }
                        : { ...list[index], state: updateData.state };
                }
            };
            updateInList(itineraries.value);
            refreshDisplayedItineraries();
            prepareItineraryOverview();
        }
        function handleShowCustomerModal(value) {
            showCustomerModal.value = value;
        }
        function openQueryItineraryIfNeeded() {
            const queryId = currentQueryItineraryId();
            if (!queryId || handledQueryItineraryId.value === queryId)
                return;
            const target = itineraries.value.find((itinerary) => String(itinerary.id) === queryId);
            if (!target)
                return;
            handledQueryItineraryId.value = queryId;
            showModal(target);
        }
        function currentQueryItineraryId() {
            const value = route?.query?.itineraryId;
            if (Array.isArray(value))
                return value[0] ? String(value[0]) : "";
            return value ? String(value) : "";
        }
        onMounted(() => {
            getItineraryData();
        });
        watch(() => currentQueryItineraryId(), (value) => {
            if (!value) {
                handledQueryItineraryId.value = null;
                return;
            }
            openQueryItineraryIfNeeded();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("itinerary.title", "Itinerarios")), 1),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("itinerary.subtitle", "Gestión general de itinerarios, estados e ingresos")), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (toggleStateFilter('PAID'))),
                        role: "button",
                        tabindex: "0",
                        class: _normalizeClass([
                            'group relative flex flex-col justify-between overflow-hidden rounded-2xl border bg-white/90 p-4.5 shadow-[0_1px_3px_rgba(0,0,0,0.03),0_6px_16px_rgba(0,0,0,0.02)] backdrop-blur-sm transition-all duration-300 ease-out cursor-pointer sm:p-5',
                            activeFilter.value.state === 'PAID'
                                ? 'border-emerald-400 ring-2 ring-emerald-500/20 shadow-[0_4px_12px_rgba(16,185,129,0.08)]'
                                : 'border-ewhite-200 hover:-translate-y-0.5 hover:border-emerald-200 hover:shadow-[0_4px_12px_rgba(16,185,129,0.06),0_12px_28px_rgba(16,185,129,0.08)]'
                        ])
                    }, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(IconCurrencyDollar), {
                                    class: "h-5 w-5",
                                    stroke: "1.75"
                                })
                            ]),
                            _createElementVNode("span", _hoisted_7, [
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "h-1.5 w-1.5 rounded-full bg-emerald-500" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(realizedPercentage.value) + "% " + _toDisplayString(_unref(t)("itinerary.overview.realized_badge", "cobrado")), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, " $" + _toDisplayString(overview.realizedIncome.toFixed(2)), 1),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("itinerary.overview.realized_income", "Ingreso realizado")), 1),
                            _createElementVNode("p", _hoisted_11, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "h-1.5 w-1.5 rounded-full bg-emerald-500" }, null, -1)),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(overview.paidItineraries), 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)("itinerary.overview.paid_itineraries", "pagados")), 1)
                            ])
                        ])
                    ], 2),
                    _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = ($event) => (toggleStateFilter('APPROVED'))),
                        role: "button",
                        tabindex: "0",
                        class: _normalizeClass([
                            'group relative flex flex-col justify-between overflow-hidden rounded-2xl border bg-white/90 p-4.5 shadow-[0_1px_3px_rgba(0,0,0,0.03),0_6px_16px_rgba(0,0,0,0.02)] backdrop-blur-sm transition-all duration-300 ease-out cursor-pointer sm:p-5',
                            activeFilter.value.state === 'APPROVED'
                                ? 'border-rajah-400 ring-2 ring-rajah-500/20 shadow-[0_4px_12px_rgba(231,129,40,0.08)]'
                                : 'border-ewhite-200 hover:-translate-y-0.5 hover:border-rajah-200 hover:shadow-[0_4px_12px_rgba(231,129,40,0.06),0_12px_28px_rgba(231,129,40,0.08)]'
                        ])
                    }, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_unref(IconClockHour4), {
                                    class: "h-5 w-5",
                                    stroke: "1.75"
                                })
                            ]),
                            _createElementVNode("span", _hoisted_15, [
                                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "h-1.5 w-1.5 rounded-full bg-rajah-500" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(receivablePercentage.value) + "% " + _toDisplayString(_unref(t)("itinerary.overview.receivable_badge", "en flujo")), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("p", _hoisted_17, " $" + _toDisplayString(overview.receivableIncome.toFixed(2)), 1),
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("itinerary.overview.receivable_income", "Por cobrar")), 1),
                            _createElementVNode("p", _hoisted_19, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "h-1.5 w-1.5 rounded-full bg-rajah-500" }, null, -1)),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(overview.approvedItineraries), 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)("itinerary.overview.approved_itineraries", "aprobados")), 1)
                            ])
                        ])
                    ], 2),
                    _createElementVNode("div", {
                        onClick: _cache[2] || (_cache[2] = ($event) => (toggleStateFilter())),
                        role: "button",
                        tabindex: "0",
                        class: _normalizeClass([
                            'group relative flex flex-col justify-between overflow-hidden rounded-2xl border bg-white/90 p-4.5 shadow-[0_1px_3px_rgba(0,0,0,0.03),0_6px_16px_rgba(0,0,0,0.02)] backdrop-blur-sm transition-all duration-300 ease-out cursor-pointer sm:p-5',
                            !activeFilter.value.state
                                ? 'border-ewhite-200 hover:-translate-y-0.5 hover:border-eblack-300 hover:shadow-[0_4px_12px_rgba(0,0,0,0.05),0_12px_28px_rgba(0,0,0,0.05)]'
                                : 'border-eblack-300 shadow-[0_1px_3px_rgba(0,0,0,0.03)] opacity-90 hover:opacity-100 hover:border-eblack-400'
                        ])
                    }, [
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createVNode(_unref(IconFileText), {
                                    class: "h-5 w-5",
                                    stroke: "1.75"
                                })
                            ]),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)("itinerary.overview.total_badge", "Volumen")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("p", _hoisted_25, _toDisplayString(overview.totalItineraries), 1),
                            _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)("itinerary.overview.total", "Total itinerarios")), 1),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", {
                                        class: "bg-emerald-500 h-full transition-all duration-500",
                                        style: _normalizeStyle({ width: `${getPercentage(overview.paidItineraries)}%` })
                                    }, null, 4),
                                    _createElementVNode("div", {
                                        class: "bg-eblue-500 h-full transition-all duration-500",
                                        style: _normalizeStyle({ width: `${getPercentage(overview.approvedItineraries)}%` })
                                    }, null, 4),
                                    _createElementVNode("div", {
                                        class: "bg-rajah-500 h-full transition-all duration-500",
                                        style: _normalizeStyle({ width: `${getPercentage(overview.pendingItineraries)}%` })
                                    }, null, 4)
                                ]),
                                _createElementVNode("p", _hoisted_29, [
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(completedCount.value) + " " + _toDisplayString(_unref(t)("itinerary.overview.active_label", "confirmados")), 1),
                                    _createElementVNode("span", null, _toDisplayString(getPercentage(completedCount.value)) + "%", 1)
                                ])
                            ])
                        ])
                    ], 2),
                    _createElementVNode("div", {
                        onClick: _cache[6] || (_cache[6] = ($event) => (toggleStateFilter('PENDING'))),
                        role: "button",
                        tabindex: "0",
                        class: _normalizeClass([
                            'group relative flex flex-col justify-between overflow-hidden rounded-2xl border bg-white/90 p-4.5 shadow-[0_1px_3px_rgba(0,0,0,0.03),0_6px_16px_rgba(0,0,0,0.02)] backdrop-blur-sm transition-all duration-300 ease-out cursor-pointer sm:p-5',
                            activeFilter.value.state === 'PENDING'
                                ? 'border-rajah-400 ring-2 ring-rajah-500/20 shadow-[0_4px_12px_rgba(231,129,40,0.08)]'
                                : 'border-ewhite-200 hover:-translate-y-0.5 hover:border-rajah-200 hover:shadow-[0_4px_12px_rgba(231,129,40,0.06),0_12px_28px_rgba(231,129,40,0.08)]'
                        ])
                    }, [
                        _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                                _createVNode(_unref(IconAlertCircle), {
                                    class: "h-5 w-5",
                                    stroke: "1.75"
                                })
                            ]),
                            _createElementVNode("span", _hoisted_33, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "h-1.5 w-1.5 rounded-full bg-rajah-500" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(getPercentage(overview.pendingItineraries)) + "% " + _toDisplayString(_unref(t)("itinerary.overview.pending_badge", "pendientes")), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("p", _hoisted_35, [
                                _createElementVNode("span", _hoisted_36, _toDisplayString(overview.pendingItineraries), 1)
                            ]),
                            _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(t)("itinerary.overview.pending", "Pendientes")), 1),
                            _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (toggleStateFilter('REJECTED')), ["stop"])),
                                    class: _normalizeClass([
                                        'inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium transition-colors',
                                        activeFilter.value.state === 'REJECTED'
                                            ? 'bg-red-100 text-red-800 ring-1 ring-red-400'
                                            : 'bg-red-50 text-red-600 hover:bg-red-100'
                                    ])
                                }, [
                                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "h-1 w-1 rounded-full bg-red-500" }, null, -1)),
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(overview.rejectedItineraries), 1),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("itinerary.overview.rejected_short", "rech.")), 1)
                                ], 2),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (toggleStateFilter('CANCELLED')), ["stop"])),
                                    class: _normalizeClass([
                                        'inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium transition-colors',
                                        activeFilter.value.state === 'CANCELLED'
                                            ? 'bg-eblack-200 text-eblack-800 ring-1 ring-eblack-400'
                                            : 'bg-eblack-100 text-eblack-600 hover:bg-eblack-200'
                                    ])
                                }, [
                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "h-1 w-1 rounded-full bg-eblack-400" }, null, -1)),
                                    _createElementVNode("span", _hoisted_40, _toDisplayString(overview.cancelledItineraries), 1),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("itinerary.overview.cancelled_short", "canc.")), 1)
                                ], 2),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (toggleStateFilter('EXPIRED')), ["stop"])),
                                    class: _normalizeClass([
                                        'inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium transition-colors',
                                        activeFilter.value.state === 'EXPIRED'
                                            ? 'bg-rose-100 text-rose-800 ring-1 ring-rose-400'
                                            : 'bg-rose-50 text-rose-600 hover:bg-rose-100'
                                    ])
                                }, [
                                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "h-1 w-1 rounded-full bg-rose-500" }, null, -1)),
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(overview.expiredItineraries), 1),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("itinerary.overview.expired_short", "exp.")), 1)
                                ], 2)
                            ])
                        ])
                    ], 2)
                ]),
                _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "bg-egreen-400 w-auto text-white px-4 py-1.5 rounded-lg text-md inline-flex justify-center items-center gap-2",
                        onClick: _cache[7] || (_cache[7] = ($event) => (showModal()))
                    }, [
                        _cache[18] || (_cache[18] = _createStaticVNode("<span><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"w-5 h-5\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0\"></path><path d=\"M9 12h6\"></path><path d=\"M12 9v6\"></path></svg></span>", 1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("itinerary.actions.new", "Nuevo")), 1)
                    ]),
                    _createVNode(ItineraryFilter, {
                        "apply-filter": applyFilter,
                        "selected-state": activeFilter.value.state
                    }, null, 8, ["selected-state"]),
                    _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                            _createVNode(_unref(IconSearch), { class: "absolute w-4 h-4 -translate-y-1/2 left-3 top-1/2 text-muted-foreground" }),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "search",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((search).value = $event)),
                                onKeyup: _cache[9] || (_cache[9] = ($event) => (applySearch())),
                                class: "rounded-lg border-ewhite-300 text-md w-full md:w-80 focus:ring-blue-500 px-4 py-1.5 pl-9",
                                placeholder: _unref(t)('itinerary.search.placeholder', 'Itinerario...')
                            }, null, 40, _hoisted_45), [
                                [_vModelText, search.value]
                            ])
                        ])
                    ])
                ]),
                (isInitialLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                            return _createVNode(ItineraryCardSkeleton, { key: n });
                        }), 64))
                    ]))
                    : (itineraries_list.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itineraries_list.value, (itinerary) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: itinerary.id
                                }, [
                                    _createVNode(ItineraryCard, {
                                        itinerary: itinerary,
                                        onShowModal: showModal,
                                        onStatusUpdated: onStatusUpdated
                                    }, null, 8, ["itinerary"])
                                ]));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                                _createVNode(_unref(IconFileText), { class: "w-10 h-10 text-eblack-400" })
                            ]),
                            _createElementVNode("p", _hoisted_50, _toDisplayString(_unref(t)("itinerary.empty", "No se encontraron itinerarios")), 1)
                        ])),
                _createVNode(CustomerModal, {
                    hidden: showCustomerModal.value,
                    handleShowCustomerModal: handleShowCustomerModal,
                    handleSetNewCustomer: handleSetNewCustomer
                }, null, 8, ["hidden"])
            ]));
        };
    }
});
